import { useSelector } from "react-redux";
import { userSelector } from "store/slices/user";

/**
 * CLE-2792 — who can see the benefit-engine configuration surfaces at all.
 *
 * 🚨 THIS IS NARROWER THAN SUPER ADMIN, DELIBERATELY, AND IT IS NOT A PERMISSION. The engine is
 * mid-cutover: these screens describe a mechanism that is not yet the one quoting patients on most
 * accounts, and a super admin who found them would reasonably read them as the live configuration.
 * So they are addressed to the two people running the cutover until it lands — the engineer making
 * the changes and the person who configures the accounts and reports what the estimates do.
 *
 * The API is unchanged and still enforces SuperAdmin. Nothing here is a security boundary — hiding
 * a screen is not access control, and this must never be the only thing standing between a user and
 * a write.
 */
export const BENEFIT_ENGINE_ADMIN_EMAILS = [
  "mike.over@clearhealthinc.com",
  "ani@clearhealthinc.com",
];

export const isBenefitEngineAdmin = (email?: string | null): boolean =>
  BENEFIT_ENGINE_ADMIN_EMAILS.includes((email ?? "").trim().toLowerCase());

export function useIsBenefitEngineAdmin(): boolean {
  const { email } = useSelector(userSelector);
  return isBenefitEngineAdmin(email);
}
